import React from "react"
import logoDM from "../../assets/images/logo-derby-museums.svg"
import logoMOM from "../../assets/images/logo-mom.svg"
import logoMAG from "../../assets/images/logo-mag.svg"
import logoPH from "../../assets/images/logo-ph.svg"

import mobileLogoColor from "../../assets/images/logo-mobile-color.svg"
import mobileLogoBlack from "../../assets/images/logo-mobile-black.svg"

import logoTextDM from "../../assets/images/venue-nav-logo-derby-museums-text.svg"
import logoTextMAG from "../../assets/images/venue-nav-logo-museum-and-art-gallery.svg"
import logoTextMOM from "../../assets/images/venue-nav-logo-museum-of-making.svg"
import logoTextPH from "../../assets/images/venue-nav-logo-pickfords-house.svg"
import { ResponsiveContext } from "grommet"

// Data
import siteContent from "../../content/siteContent"

// Styles
import * as styles from "./Logo.module.scss"
import Hamburger from "./Hamburger"
import NavigationMobile from "./NavigationMobile"
import NavigationVenue from "./NavigationVenue"
import Navigation from "./Navigation"

const Logo = props => {
  const currentVenue = props.venue.theme

  let logoImage = logoDM
  let mobileLogoImage = mobileLogoColor
  let logoTextImage = logoTextDM
  let homeURL = "/"

  switch (currentVenue) {
    case "MAG":
      logoImage = logoMAG
      mobileLogoImage = mobileLogoBlack
      logoTextImage = logoTextMAG
      homeURL = "/museum-and-art-gallery"
      break
    case "MOM":
      logoImage = logoMOM
      mobileLogoImage = logoMOM // Same logo as desktop for MOM
      logoTextImage = false // Logo not needed on MOM
      homeURL = "/museum-of-making"
      break
    case "PH":
      logoImage = logoPH
      mobileLogoImage = mobileLogoBlack
      logoTextImage = logoTextPH
      homeURL = "/pickfords-house"
      break
  }

  return (
    <div className={`${styles.Logo} venue${currentVenue}`}>
      <a href={homeURL}>
        <ResponsiveContext.Consumer>
          {responsive =>
            responsive === "smallMobile" || responsive === "mobile" ? (
              <img src={mobileLogoImage} alt="Logo" />
            ) : (
              <img src={logoImage} alt="Logo" />
            )
          }
        </ResponsiveContext.Consumer>
        {logoTextImage && (
          <ResponsiveContext.Consumer>
            {responsive => {
              if (responsive === "smallMobile" || responsive === "mobile") {
                return (
                  <div className={styles.mobileLogoText}>
                    <img src={logoTextImage} alt="Logo" />
                  </div>
                )
              }
            }}
          </ResponsiveContext.Consumer>
        )}
      </a>
    </div>
  )
}

export default Logo
